import {
  API_HOST_YUNDIAN,
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST_YUNDIAN
})
// axiosPhp.defaults.baseURL = API_HOST_YUNDIAN
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}

// 返回处理
axiosPhp.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code == 101) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    console.log('删除了对象yunxiao.js')
    Lockr.rm('firstRoutePath')
    // // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101) {
    //_g.toastMsg('error', response.data.error)
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 添加请求拦截器
axiosPhp.interceptors.request.use(config => {
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({
      u: config.url + '&' + config.method,
      f: c
    })
  })
  return config
}, error => {
  return Promise.reject(error)
})


// 首页-预警消息列表
export  function getListByPage(params){
  return axiosPhp({
    url:'systemWarnMessage/getListByPage',
    method:'get',
    params
  })
}
// 首页-消息全部标记已读接口
export  function readAll(params){
  return axiosPhp({
    url:'systemWarnMessage/readAll',
    method:'post',
    data:params
  })
}
